import Http from '@/services/http';
import {
  LatestManeuversRequest,
  ManeuverData,
  ManeuverDetailedData,
} from 'sigma-mappings';
import translate from '@/services/translate';

/* istanbul ignore next */
function maneuverNameFormatter(maneuver) {
  const maneuverType = translate(`enums.maneuver-type.${maneuver.maneuverType}`);
  const maneuverLabel = translate('reports.oscillography.view-report.maneuver');
  return `${maneuverType} - ${maneuverLabel} ${maneuver.maneuverId}`;
}

/* istanbul ignore next */
function mapManeuversName(data) {
  const newData = { ...data };

  if (!newData.chartData) {
    newData.chartData = [];
  }
  if (!newData.diagnosticsChartData) {
    newData.diagnosticsChartData = [];
  }

  newData.maneuvers = newData.maneuvers.map(maneuver => ({
    ...maneuver,
    name: maneuverNameFormatter(maneuver),
  }));
  return newData;
}

const urls = {
  maneuverChartData: sensorId => `/supervisao/oscilografia/${sensorId}/ultimas-manobras`,
};

export default {
  getManeuverData(sensorId, maneuverType, chartFilters) {
    const params = new LatestManeuversRequest({ ...chartFilters, maneuverType });
    return new Http()
      .get(urls.maneuverChartData(sensorId), { params })
      .then(({ data, status }) => {
        if (status === 204) return null;
        return new ManeuverData(data);
      });
  },
  getMoreDetailsData(sensorId, maneuverType, chartFilters) {
    const params = new LatestManeuversRequest({ ...chartFilters, maneuverType });
    return new Http()
      .get(urls.maneuverChartData(sensorId), { params })
      .then(({ data, status }) => {
        if (status === 204) return null;
        const mappedResponse = new ManeuverDetailedData(data);
        return mapManeuversName(mappedResponse);
      });
  },
};
